import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import { BackendView, View } from '../../viewsSearch/types/ViewTypes';
import {
  convertInternalViewToBEFormat,
  transformBackendViewToInternalFormat,
} from '../../viewsSearch/dataOperators/backendViews';
import { VIEWS_SEARCH_QUERY_NAME } from '../../viewsSearch/hooks/useFetchViewsSearch';

export const CREATE_SINGLE_VIEW_MUTATION_NAME = 'createSingleView' as const;

export type ViewWithoutIdOrOwnerIdOrType = Omit<
  View,
  'id' | 'ownerId' | 'type' | 'idLabel'
> & { clonedFromViewId?: string };

const createViewMutationArgsArgument: (keyof ViewWithoutIdOrOwnerIdOrType)[] = [
  'objectTypeId',
  'name',
  'state',
  'teamId',
  'private',
  'namespaceName',
  'clonedFromViewId',
  'publicDefaultRole',
];

export const CreateSingleViewMutation = registerMutation<
  typeof CREATE_SINGLE_VIEW_MUTATION_NAME,
  ViewWithoutIdOrOwnerIdOrType,
  View
>({
  fieldName: CREATE_SINGLE_VIEW_MUTATION_NAME,
  args: createViewMutationArgsArgument,
  fetcher: (args) => {
    const clonedFromViewIdParam = args.clonedFromViewId
      ? `&clonedFromViewId=${args.clonedFromViewId}`
      : '';
    return http
      .post(
        `/sales/v4/views?namespace=${args.namespaceName}${clonedFromViewIdParam}`,
        {
          //we ignore this error because we are explicitly omotting the id of the view - this is the only case this should be needed
          data: convertInternalViewToBEFormat(args as unknown as View, [
            // Until we have a way to set the view color, we want the auto-generated view color
            'viewColor',
          ]),
        }
      )
      .then((result) => {
        return transformBackendViewToInternalFormat(result as BackendView);
      });
  },
});

export const useCreateSingleViewMutation = (
  view: ViewWithoutIdOrOwnerIdOrType
) => {
  return useMutation(CreateSingleViewMutation, {
    variables: view,
    refetchQueries: [VIEWS_SEARCH_QUERY_NAME],
    awaitRefetchQueries: true,
  });
};
